
import Vue from "vue";
import { avatars } from "../App.vue";

export default Vue.extend({
  name: "PlayerAvatarContainer",
  props: {
    playerId: Number,
    selectedId: Number,
    size: Number,
  },
  computed: {
    selectedClass: {
      cache: false,
      get(): string {
        if (this.playerId === this.selectedId) {
          return "player-avatar-background-selected";
        }
        return "";
      },
    },
    heightScaled: {
      get(): number {
        return 0.675 * this.size;
      },
    },
    fill: {
      get(): string {
        return avatars[this.playerId].fill;
      },
    },
  },
});
